/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FlagSchema
 */
export interface FlagSchema {
    /**
     * 
     * @type {string}
     * @memberof FlagSchema
     */
    label: string;
}

/**
 * Check if a given object implements the FlagSchema interface.
 */
export function instanceOfFlagSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "label" in value;

    return isInstance;
}

export function FlagSchemaFromJSON(json: any): FlagSchema {
    return FlagSchemaFromJSONTyped(json, false);
}

export function FlagSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlagSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': json['label'],
    };
}

export function FlagSchemaToJSON(value?: FlagSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': value.label,
    };
}

